var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-footer',{staticClass:"footer"},[_vm._v(_vm._s(_vm.footer))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }